import { useQuery } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { useParams } from "react-router-dom"
import { getRatingFetch, getRatingsFetch, getScoreRatingMethodFetch } from "store/middlewares/rating.crud"
import { ScoreRatingMethodVM } from "models/VM"

const useGetRating = () => {
    const params = useParams()
    const dispatch = useDispatch()
    const { assessment } = useSelector(state => state.assessment)
    const assessmentID = params?.assessmentID || assessment.id

    return useQuery(
        {
            queryKey: [qc.rating, assessmentID],
            queryFn: async ({ signal }) => {
                const { data } = await getRatingFetch({ id: assessment.id, signal, })
                dispatch(actions.setRating(data.rating))
                return data.rating
            },
            enabled: !!assessmentID,
        })
}

const useGetRatings = () => {
    return useQuery({
        queryKey: [qc.ratings],
        queryFn: async () => {
            let ratings = []
            const { data } = await getRatingsFetch()
            const ratingLen = data.length
            data.forEach((ratingItem, index) => {
                ratings.push(new ScoreRatingMethodVM({ ...ratingItem, index: index }))
            })
            return ratings
        },
        enabled: false
    })
}

export default { useGetRatings, useGetRating }